import { Modal, inputCls, btnPrimary, btnTurq } from "../bits";

export function StaffImportModal({ open, onClose, fileRef, busy, onImport }) {
  return (
    <Modal open={open} onClose={onClose} title="استيراد الموظفين المتطوعين من Excel" testid="staff-import-modal">
      <div className="space-y-4">
        <p className="text-xs text-mutext leading-relaxed">
          القالب يحتوي: <b>الاسم الرباعي</b>، <b>المسمى الوظيفي</b>، <b>عدد الساعات التطوعية</b>. التكرار بالاسم يُكتشف تلقائياً.
        </p>
        <input ref={fileRef} data-testid="staff-import-file-input" type="file" accept=".xlsx,.xlsm" className={inputCls} />
        <button data-testid="staff-import-submit-btn" onClick={onImport} disabled={busy} className={`${btnTurq} w-full justify-center`}>
          {busy ? "جارٍ الاستيراد …" : "بدء الاستيراد"}
        </button>
      </div>
    </Modal>
  );
}

export function StaffReportModal({ report, onClose }) {
  return (
    <Modal open={!!report} onClose={onClose} title="تقرير الاستيراد" testid="staff-import-report-modal">
      {report && (
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="rounded-xl bg-turq-100 dark:bg-surface2 p-4">
              <div data-testid="staff-import-imported" className="font-head font-black text-2xl text-turq-900 dark:text-turq-300">{report.imported}</div>
              <div className="text-[11px] text-mutext">سجل مستورد</div>
            </div>
            <div className="rounded-xl bg-beige-600 dark:bg-surface2 p-4">
              <div data-testid="staff-import-duplicates" className="font-head font-black text-2xl text-turq-900 dark:text-turq-300">{report.duplicates}</div>
              <div className="text-[11px] text-mutext">سجل مكرر</div>
            </div>
            <div className="rounded-xl bg-coral-100 dark:bg-surface2 p-4">
              <div data-testid="staff-import-rejected" className="font-head font-black text-2xl text-coral-900 dark:text-coral-300">{report.rejected.length}</div>
              <div className="text-[11px] text-mutext">سجل مرفوض</div>
            </div>
          </div>
          {report.rejected.length > 0 && (
            <div className="max-h-48 overflow-auto rounded-xl border border-brd">
              <table className="w-full text-xs">
                <thead><tr className="bg-coral-100 text-coral-900"><th className="px-3 py-2 text-right">الصف</th><th className="px-3 py-2 text-right">السبب</th></tr></thead>
                <tbody>
                  {report.rejected.map((r) => (
                    <tr key={r.row} data-testid={`staff-rejected-row-${r.row}`} className="border-t border-brd/50">
                      <td className="px-3 py-2 font-bold">{r.row}</td>
                      <td className="px-3 py-2">{r.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <button data-testid="staff-import-report-close" onClick={onClose} className={`${btnPrimary} w-full justify-center`}>تم</button>
        </div>
      )}
    </Modal>
  );
}
